import { Configurable, CountryConfig, createSiteConfig } from '@crystal/config'

import * as sites from './sites'
import { MfSiteConfig } from './types'

const defaultMfSiteConfig = Configurable.props<MfSiteConfig>({
  socialProviders: [
    {
      id: 'apple',
      displayName: 'Apple',
    },
    {
      id: 'facebook',
      displayName: 'Facebook',
    },
    {
      id: 'google',
      displayName: 'Google',
    },
  ],
  preSelectedPersistentLogin: true,
  legalPolicy: {
    minAgeRequired: false,
    helpPagesUrls: {
      termsAndConditions: '/terms_and_conditions',
    },
  },
  suggestSocialLogin: [
    {
      id: 'google',
      domains: ['gmail.com'],
    },
  ],
})

export function getMfSiteConfig() {
  return createSiteConfig<MfSiteConfig>(
    sites as Record<string, CountryConfig<MfSiteConfig> | undefined>,
    defaultMfSiteConfig,
  )
}
